(function () {
  "use strict";

  var busy = false;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function propsOf(item) {
    return (item && item.properties) || {};
  }

  function isVesselItem(item) {
    var p = propsOf(item);
    return p._dh_vessel === "1" || p._dh_vessel === 1;
  }

  function findPairedVessel(cart, perfume) {
    var p = propsOf(perfume);
    var kit = p._dh_kit || "";
    var sku = p["Артикул"] || p["SKU"] || p["Article"] || "";
    var items = (cart && cart.items) || [];
    var i;
    var it;
    var ip;
    if (kit) {
      for (i = 0; i < items.length; i++) {
        it = items[i];
        ip = propsOf(it);
        if (isVesselItem(it) && ip._dh_kit === kit) return it;
      }
    }
    if (sku) {
      for (i = 0; i < items.length; i++) {
        it = items[i];
        ip = propsOf(it);
        if (isVesselItem(it) && String(ip._dh_parent || "") === String(sku)) return it;
      }
    }
    return null;
  }

  function cartJson() {
    return fetch(root + "cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function updateCart(updates) {
    return fetch(root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      return r.json();
    });
  }

  function refreshUi(cart) {
    var count = (cart && cart.item_count) || 0;
    document.documentElement.className = document.documentElement.className.replace(
      /t4s-cart-count-\d+/,
      "t4s-cart-count-" + count
    );
    document.querySelectorAll("[data-cart-count], .t4s_crcount, .t4s-count").forEach(function (el) {
      if (el.hasAttribute("data-cart-count") || /^\d+$/.test((el.textContent || "").trim())) {
        el.textContent = String(count);
      }
    });

    var jobs = [
      fetch(root + "?section_id=mini_cart", { credentials: "same-origin" })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.getElementById("t4s-mini_cart");
          var cur = document.getElementById("t4s-mini_cart");
          if (fresh && cur) cur.outerHTML = fresh.outerHTML;
        }),
    ];

    // Refresh cart page HTML without a full reload.
    if (document.querySelector(".t4s-page_cart__item, .t4s-page_cart")) {
      jobs.push(
        fetch(root + "cart", { credentials: "same-origin" })
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var fresh = doc.getElementById("MainContent");
            var cur = document.getElementById("MainContent");
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          })
      );
    }

    return Promise.all(jobs);
  }

  function lineKeyFromEl(el) {
    if (!el) return "";
    var item = el.closest("[data-cart-item]");
    if (!item) return "";
    if (item.getAttribute("data-key")) return item.getAttribute("data-key");
    var remove = item.querySelector("[data-cart-remove][data-id]");
    if (remove) return remove.getAttribute("data-id");
    var input = item.querySelector("[data-quantity-value][data-id]");
    if (input) return input.getAttribute("data-id");
    return "";
  }

  function isVesselEl(el) {
    var item = el && el.closest("[data-cart-item]");
    return !!(
      item &&
      (item.classList.contains("dh-cart-item--vessel") || item.getAttribute("data-dh-role") === "vessel")
    );
  }

  function isKitParentEl(el) {
    var item = el && el.closest("[data-cart-item]");
    if (!item || isVesselEl(item)) return false;
    return !!(item.getAttribute("data-dh-kit") || item.getAttribute("data-dh-sku"));
  }

  function runKit(perfumeKey, qty) {
    if (busy || !perfumeKey) return Promise.resolve();
    busy = true;
    return cartJson()
      .then(function (cart) {
        var perfume = (cart.items || []).filter(function (it) {
          return it.key === perfumeKey;
        })[0];
        var updates = {};
        updates[perfumeKey] = qty;
        var vessel = perfume ? findPairedVessel(cart, perfume) : null;
        if (vessel) updates[vessel.key] = qty;
        return updateCart(updates);
      })
      .then(function (cart) {
        return refreshUi(cart);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  }

  document.addEventListener(
    "click",
    function (e) {
      var vesselCtrl = e.target.closest(
        "[data-cart-remove], .t4s-page_cart__remove, .t4s-mini_cart__remove, [data-decrease-qty], [data-increase-qty]"
      );
      if (vesselCtrl && isVesselEl(vesselCtrl)) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      var remove = e.target.closest("[data-cart-remove], .t4s-page_cart__remove, .t4s-mini_cart__remove");
      if (remove) {
        var key = remove.getAttribute("data-id") || lineKeyFromEl(remove);
        e.preventDefault();
        e.stopPropagation();
        runKit(key, 0);
        return;
      }

      var minus = e.target.closest("[data-decrease-qty]");
      if (minus && isKitParentEl(minus)) {
        var wrap = minus.closest("[data-quantity-wrapper]");
        var input = wrap && wrap.querySelector("[data-quantity-value]");
        var keyMinus = (input && input.getAttribute("data-id")) || lineKeyFromEl(minus);
        var cur = input ? parseInt(input.value, 10) : 1;
        e.preventDefault();
        e.stopPropagation();
        runKit(keyMinus, cur <= 1 ? 0 : cur - 1);
        return;
      }

      var plus = e.target.closest("[data-increase-qty]");
      if (plus && isKitParentEl(plus)) {
        var wrapPlus = plus.closest("[data-quantity-wrapper]");
        var inputPlus = wrapPlus && wrapPlus.querySelector("[data-quantity-value]");
        var keyPlus = (inputPlus && inputPlus.getAttribute("data-id")) || lineKeyFromEl(plus);
        var curPlus = inputPlus ? parseInt(inputPlus.value, 10) : 1;
        e.preventDefault();
        e.stopPropagation();
        runKit(keyPlus, curPlus + 1);
      }
    },
    true
  );

  document.addEventListener(
    "change",
    function (e) {
      var input = e.target.closest("[data-quantity-value]");
      if (!input) return;
      if (isVesselEl(input)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        input.value = input.getAttribute("data-current-qty") || "1";
        return;
      }
      if (!isKitParentEl(input)) return;
      var n = parseInt(input.value, 10);
      e.preventDefault();
      e.stopImmediatePropagation();
      runKit(input.getAttribute("data-id") || lineKeyFromEl(input), !n || n < 1 ? 0 : n);
    },
    true
  );

  var cartClean = null;
  var productCache = {};

  function vesselCatalog() {
    var node = document.getElementById("dh-vessel-catalog");
    if (!node) return null;
    var data;
    try {
      data = JSON.parse(node.textContent || "");
    } catch (err) {
      return null;
    }
    var catalog = data && data.catalog;
    if (!catalog || catalog.enabled !== true) return null;
    var allowed = {};
    var volumes = catalog.volumes || {};
    Object.keys(volumes).forEach(function (key) {
      var list = (volumes[key] && volumes[key].vessels) || [];
      list.forEach(function (vessel) {
        if (vessel && vessel.code) allowed[String(vessel.code)] = true;
      });
    });
    return { allowed: allowed, message: (data && data.message) || "" };
  }

  function findPerfumeForVessel(cart, vessel) {
    var vp = propsOf(vessel);
    var kit = vp._dh_kit || "";
    var parent = String(vp._dh_parent || "");
    var items = (cart && cart.items) || [];
    var i;
    var it;
    var ip;
    var sku;
    for (i = 0; i < items.length; i++) {
      it = items[i];
      if (isVesselItem(it)) continue;
      ip = propsOf(it);
      if (kit && ip._dh_kit === kit) return it;
      sku = String(ip["Артикул"] || ip["SKU"] || ip["Article"] || it.sku || "");
      if (parent && (sku === parent || sku.indexOf(parent + "-") === 0)) return it;
    }
    return null;
  }

  function storeLang() {
    return (document.documentElement.getAttribute("lang") || "").toLowerCase();
  }

  function notice(uk, tr, en) {
    var lang = storeLang();
    if (lang.indexOf("uk") === 0 || lang.indexOf("ru") === 0) return uk;
    if (lang.indexOf("tr") === 0) return tr;
    return en;
  }

  function stockNoticeText(kind) {
    var spec = vesselCatalog();
    if (kind === "vessel") {
      return (
        (spec && spec.message) ||
        notice(
          "Цю тару вже розпродано. Оберіть об’єм ще раз.",
          "Bu şişe artık stokta yok. Hacmi yeniden seçin.",
          "This bottle is no longer available. Please choose the volume again."
        )
      );
    }
    if (kind === "check") {
      return notice(
        "Не вдалося перевірити наявність. Спробуйте ще раз.",
        "Stok kontrol edilemedi. Lütfen tekrar deneyin.",
        "Could not check stock. Please try again."
      );
    }
    return notice(
      "Цей товар уже немає в наявності. Його прибрано з кошика.",
      "Bu ürün artık stokta yok. Sepetten kaldırıldı.",
      "This item is no longer available. It has been removed from the cart."
    );
  }

  function showStockNotice(message) {
    if (!message) return;
    var old = document.getElementById("dh-vessel-retired-note");
    if (old) old.remove();
    var note = document.createElement("div");
    note.id = "dh-vessel-retired-note";
    note.setAttribute("role", "status");
    note.textContent = message;
    note.style.cssText =
      "position:fixed;left:16px;right:16px;bottom:16px;z-index:99999;background:#111;color:#fff;padding:14px 16px;font:14px/1.4 sans-serif;max-width:420px;margin:0 auto;";
    document.body.appendChild(note);
  }

  function productJson(handle) {
    if (!handle) return Promise.resolve({ missing: true });
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + "products/" + encodeURIComponent(handle) + ".js", {
        credentials: "same-origin",
      })
        .then(function (r) {
          if (r.status === 404) return { missing: true };
          if (!r.ok) return { error: true };
          return r.json();
        })
        .catch(function () {
          return { error: true };
        });
    }
    return productCache[handle];
  }

  function allowedQty(item, product) {
    if (!product || product.missing) return 0;
    if (product.error) return -1;
    var variants = product.variants || [];
    var vid = Number(item.variant_id);
    var v = null;
    var i;
    for (i = 0; i < variants.length; i++) {
      if (Number(variants[i].id) === vid) {
        v = variants[i];
        break;
      }
    }
    if (!v) return 0;
    if (typeof v.inventory_quantity === "number" && String(v.inventory_management || "") === "shopify") {
      if (v.inventory_quantity <= 0) return 0;
      if (v.inventory_quantity < item.quantity) return v.inventory_quantity;
    }
    if (v.available !== true) return 0;
    return item.quantity;
  }

  function cartStockMap() {
    return fetch(root + "?sections=dh-cart-stock", { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) return {};
        return r.json();
      })
      .then(function (data) {
        var html = (data && data["dh-cart-stock"]) || "";
        var match = String(html).match(/<script[^>]*id="dh-cart-stock-data"[^>]*>([\s\S]*?)<\/script>/);
        if (!match) return {};
        var parsed = JSON.parse(match[1]);
        var map = {};
        ((parsed && parsed.lines) || []).forEach(function (line) {
          if (line && line.key) map[line.key] = line;
        });
        return map;
      })
      .catch(function () {
        return {};
      });
  }

  function qtyFromTrackedStock(item, line) {
    if (!line) return null;
    if (line.available === false) return 0;
    if (line.managed !== true || typeof line.qty !== "number") return null;
    if (line.qty <= 0) return 0;
    if (line.qty < item.quantity) return line.qty;
    return item.quantity;
  }

  function dropKit(updates, cart, item) {
    updates[item.key] = 0;
    if (isVesselItem(item)) {
      var perfume = findPerfumeForVessel(cart, item);
      if (perfume) updates[perfume.key] = 0;
      return;
    }
    var vessel = findPairedVessel(cart, item);
    if (vessel) updates[vessel.key] = 0;
  }

  function purgeUnavailableCart() {
    productCache = {};
    return cartJson()
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        if (!items.length) return { removed: false, uncertain: false };
        var spec = vesselCatalog();
        return cartStockMap().then(function (stockMap) {
        return Promise.all(
          items.map(function (it) {
            if (spec && isVesselItem(it) && !spec.allowed[String(it.sku || "")]) {
              return { item: it, qty: 0, vesselGone: true };
            }
            var tracked = qtyFromTrackedStock(it, stockMap[it.key]);
            if (tracked !== null) {
              return { item: it, qty: tracked, vesselGone: false };
            }
            return productJson(it.handle).then(function (product) {
              return { item: it, qty: allowedQty(it, product), vesselGone: false };
            });
          })
        );
        }).then(function (rows) {
          var updates = {};
          var removed = false;
          var reduced = false;
          var uncertain = false;
          var vesselGone = false;
          rows.forEach(function (row) {
            if (row.qty < 0) {
              uncertain = true;
              return;
            }
            if (row.qty === row.item.quantity) return;
            if (row.qty === 0) {
              dropKit(updates, cart, row.item);
              removed = true;
              if (row.vesselGone) vesselGone = true;
            } else {
              updates[row.item.key] = row.qty;
              reduced = true;
            }
          });
          if (!removed && !reduced) return { removed: false, uncertain: uncertain };
          return updateCart(updates).then(function (next) {
            showStockNotice(stockNoticeText(vesselGone ? "vessel" : "stock"));
            return refreshUi(next).then(function () {
              return { removed: true, uncertain: uncertain };
            });
          });
        });
      })
      .catch(function () {
        return { removed: false, uncertain: true };
      });
  }

  function ensureCartClean(force) {
    if (force) cartClean = null;
    if (!cartClean) cartClean = purgeUnavailableCart();
    return cartClean;
  }

  function checkoutEl(target) {
    if (!target || !target.closest) return null;
    return target.closest(
      'a[href*="/checkout"], a[href*="chekly-app.com"], a[href*="checkout.intoxication.com.ua"], a[href*="checkout.shopintoxication.com"], a[href*="checkout.intoxication.tr"], [name="checkout"], button[name="checkout"], [data-shopify="payment-button"], .shopify-payment-button, form[action="/checkout"], form[action*="/checkout"]'
    );
  }

  function isBuyNowEl(el) {
    if (!el || !el.closest) return false;
    if (el.closest('[data-shopify="payment-button"], .shopify-payment-button')) return true;
    var form = el.closest("form");
    if (!form) return false;
    if (form.getAttribute("data-skip-cart") === "true") return true;
    var back = form.querySelector('input[name="return_to"]');
    return !!(back && String(back.value || "").indexOf("checkout") >= 0);
  }

  function variantIdFrom(el) {
    var form = (el && el.closest && el.closest("form")) || document.querySelector('form[action*="/cart/add"]');
    if (!form) return "";
    var input = form.querySelector('[name="id"], [name="variant_id"]');
    return (input && input.value) || "";
  }

  function domVariantQty(variantId) {
    if (!variantId) return null;
    var node = document.querySelector('option[value="' + String(variantId).replace(/"/g, "") + '"]');
    if (!node) return null;
    var raw = node.getAttribute("data-inventoryquantity");
    if (raw == null || raw === "") raw = node.getAttribute("data-inventoryQuantity");
    if (raw == null || raw === "") return null;
    var qty = Number(raw);
    return isFinite(qty) ? qty : null;
  }

  function buyNowQty(el) {
    var vid = variantIdFrom(el);
    var domQty = domVariantQty(vid);
    if (domQty !== null) return Promise.resolve(domQty);
    var handle = "";
    var path = (location.pathname || "");
    var match = path.match(/\/products\/([^/?#]+)/);
    if (match) handle = decodeURIComponent(match[1]);
    if (!handle || !vid) return Promise.resolve(-1);
    return productJson(handle).then(function (product) {
      if (!product || product.missing) return 0;
      if (product.error) return -1;
      var variants = product.variants || [];
      var i;
      for (i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(vid)) {
          if (variants[i].available !== true) return 0;
          if (typeof variants[i].inventory_quantity === "number") {
            return variants[i].inventory_quantity <= 0 ? 0 : variants[i].inventory_quantity;
          }
          return -1;
        }
      }
      return 0;
    });
  }

  var passUntil = 0;

  function lettingThrough(el) {
    if (Date.now() < passUntil) return true;
    return !!(el && el.getAttribute && el.getAttribute("data-dh-stock-ok") === "1");
  }

  function openCheckout(el, type) {
    passUntil = Date.now() + 1500;
    if (el && el.setAttribute) el.setAttribute("data-dh-stock-ok", "1");
    if (type === "submit") {
      el.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    } else {
      el.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true, view: window }));
      el.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
    }
    setTimeout(function () {
      if (el && el.removeAttribute) el.removeAttribute("data-dh-stock-ok");
    }, 0);
  }

  function approveCheckout(el, type) {
    var checkBuy = isBuyNowEl(el) ? buyNowQty(el) : Promise.resolve(1);
    return checkBuy.then(function (qty) {
      if (qty < 0) {
        showStockNotice(stockNoticeText("check"));
        return false;
      }
      if (qty === 0) {
        showStockNotice(stockNoticeText("stock"));
        return false;
      }
      return ensureCartClean(true).then(function (result) {
        cartClean = null;
        if (!result || result.removed || result.uncertain) {
          if (result && result.uncertain && !result.removed) {
            showStockNotice(stockNoticeText("check"));
          }
          return false;
        }
        openCheckout(el, type);
        return true;
      });
    });
  }

  var gate = false;

  function onCheckoutIntent(e) {
    var el = checkoutEl(e.target);
    if (!el) {
      var form = e.target && e.target.closest && e.target.closest("form");
      if (e.type === "submit" && form && isBuyNowEl(form)) el = form;
    }
    if (!el || lettingThrough(el)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (gate) return;
    gate = true;
    var type = e.type === "submit" ? "submit" : "mousedown";
    approveCheckout(el, type)
      .catch(function () {
        showStockNotice(stockNoticeText("stock"));
      })
      .then(function () {
        gate = false;
      });
  }

  ["pointerdown", "mousedown", "touchend", "click", "submit"].forEach(function (type) {
    window.addEventListener(type, onCheckoutIntent, true);
  });

  window.addEventListener(
    "click",
    function (e) {
      var add = e.target && e.target.closest && e.target.closest('[name="add"]');
      if (!add) return;
      var qty = domVariantQty(variantIdFrom(add));
      if (qty === null || qty > 0) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showStockNotice(stockNoticeText("stock"));
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      ensureCartClean();
    });
  } else {
    ensureCartClean();
  }
})();
